<script>
export default {
  translate25Context: "plan",
  components: {},
  methods: {},
  props: ["component", "handler"],
  data: function () {
    return {
      opened: false,
      active: false,
    };
  },
  computed: {
    hours: function () {
      return parseInt(this.component.minutes / 60);
    },
    minutes: function () {
      return this.component.minutes % 60;
    },
    warning: function () {
      return this.component.minutes < 30;
    },
    danger: function () {
      return this.component.minutes == 0;
    },
  },
};
</script>

<template>
  <div class="plan-upthere">
    <f-drop-down-box ref="dropdownSold" variant="rightanchor" @update:opened="(opened) => (active = opened)">
      <template v-slot:button>
        <f-button type="upthere" @click="$refs.dropdownSold.toggle()">
          <f-icon icon="fa6-clock"></f-icon>
          <span v-if="hours">{{ hours }} {{ $vtc("hour|hours", hours) }}</span>
          <span v-if="minutes">{{ minutes }} {{ $vtc("minute|minutes", minutes) }}</span>
          <span v-if="!hours && !minutes">{{ $vt("0 minutes") }}</span>
        </f-button>
      </template>

      <template v-slot:dropdown>
        <div>
          <f-drop-down-header :label="$vt('Available hours')" icon="fa6-clock"></f-drop-down-header>
          <div class="plan-drop-down-content plan-upthere-streaming-hours">
            <div class="streaming-hours" v-if="(hours > 0 || minutes > 0)">
              {{ $vt("You can stream up to") }}
              <span class="value">
                <span v-if="hours">{{ hours }} {{ $vtc("hour|hours", hours) }}</span>
                <span v-if="minutes">{{ minutes }} {{ $vtc("minute|minutes", minutes) }}</span>
                <span v-if="!hours && !minutes">{{ $vtc("minute|minutes", 0) }}</span>
              </span>
            </div>
            <div class="streaming-hours" v-else>
              {{ $vt("You have spent all your available hours") }}
            </div>
            <f-button type="primary" v-if="component.hour_price && !component.expired" href="#/extra_hours">
              {{ $vt("Buy extra hours") }} <f-icon icon="fa6-plus"></f-icon>
            </f-button>
            <f-button type="secondary" href="#/account">
              {{ $vt("History") }} <f-icon icon="fa6-circle-arrow-up"></f-icon>
            </f-button>
          </div>
        </div>
      </template>
    </f-drop-down-box>
    <f-drop-down-box ref="dropdownPlan" variant="rightanchor" @update:opened="(opened) => (active = opened)">
      <template v-slot:button>
        <f-button class="upthere" :class="{ active }" @click="$refs.dropdownPlan.toggle()">
          {{ component.plan_title }}
        </f-button>
      </template>

      <template v-slot:dropdown>
        <div>
          <f-drop-down-header :label="$vt('Current plan')"></f-drop-down-header>
          <div class="plan-drop-down-content">
            <div class="plan-upthere-plan-title">
              {{ component.plan_title }}
            </div>

            <ul class="plan-upthere-feature">
              <li v-if="component.def__viewers_limit">
                {{ $vt("Up to") }} <strong>{{ component.def__viewers_limit }}</strong> {{ $vtc("viewer|viewers", component.def__viewers_limit) }}
              </li>
              <li v-if="component.def__vod_availability">
                {{ $vt("Replay avalable for") }} <strong>{{ $vt(component.def__vod_availability) }}</strong>
              </li>
              <li v-if="component.renewale_date">
                <span v-if="!component.next_session">{{ $vt("Expire") }}</span>
                <span v-if="component.next_session">{{ $vt("Renew") }}</span>
                <strong>
                  <MediumDate :timestamp="component.renewale_date" />
                  {{ $d(component.renewale_date, 'medium') }}
                </strong>
              </li>
            </ul>
            <f-button type="primary" href="#/purchase">
              {{ $vt("Upgrade") }} <f-icon icon="fa6-circle-arrow-up"></f-icon>
            </f-button>
            <VuePlaceholder v-if="component.time_travel" :component="component.time_travel" :handler="handler" />
          </div>
        </div>
      </template>
    </f-drop-down-box>
  </div>
</template> 

<style lang="scss">
.plan-upthere {
  display: flex;
  gap: 16px;


  .plan-drop-down-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: var(--white-a50);
    /* Text/Font-size 100/Semi-bold */
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;

    .plan-upthere-feature {
      padding-left: 16px;
      margin: 0;

      color: var(--white-a75);
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 200%;
      /* 28px */
    }
    .f-button {
      font-family: Lato;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      font-size: 12px;
      padding: 8px 16px;
      .f-icon {
        font-size: 20px;
        margin-left: auto;
      }
    }
  }

  .plan-upthere-streaming-hours {
    .streaming-hours {
      > .value {
        color: var(--white-a75);
      }
    }
  }

  .plan-upthere-plan-title {
    align-self: center;
    padding: 8px 12px 8px 12px;
    border-radius: 24px;
    background-color: var(--white-a25);

    text-transform: uppercase;
    font-family: Lato;
    font-size: 12px;
    font-weight: 700;
    line-height: 14.4px;
    text-align: left;
    color: var(--white-a75);
  }

  .plan-upthere-plan-sold,
  .plan-upthere-viewers-number {
    color: var(--white-a75);
  }
}
</style>